'use client';

import type { PropsWithChildren, ReactNode } from 'react';

import { useIsNonPremiseReport } from './useUpdateLocationOnReport';

export interface HideFromNonPremiseProps extends PropsWithChildren {
	nonPremiseContent?: ReactNode;
}

/**
 * Use this when we want to exclude content from showing up for non-premise reports
 * @param props
 * @returns
 */
export function HideFromNonPremiseReport({ nonPremiseContent, children }: HideFromNonPremiseProps): ReactNode {
	const nonPremise = useIsNonPremiseReport();

	if (nonPremise) {
		return nonPremiseContent ?? null;
	}

	return children;
}
